"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FOLDER_PAYMENT_STATUSES_LENGTH = exports.FOLDER_PAYMENT_STATUS_OPTIONS = exports.FolderMetaTypeDomain = exports.MASS_GET_PARTICIPANTS_CHUNK_SIZE = void 0;
const folders_enums_1 = require("../../folders/types/folders.enums");
const payment_enums_1 = require("../../payment/types/enums/payment.enums");
exports.MASS_GET_PARTICIPANTS_CHUNK_SIZE = 100;
exports.FolderMetaTypeDomain = {
    // MetaType.UNSPECIFIED implicitly indicates Folders created by the system for segments (ie. quasi-shadow Folders for ProgramSeasons-acting-as-segments)
    // It is *not* used for the root ProgramSeason Folder (despite it being a system-created Folder)
    SYSTEM_CONTROLLED: folders_enums_1.MetaTypeEnum.UNSPECIFIED,
    // MetaType.GROUP is Used by Session Participants to indicate the root ProgramSeason Folder and any additional Folders created by the user
    USER_CONTROLLED: folders_enums_1.MetaTypeEnum.GROUP,
    ALL_SESSION_PARTICIPANTS: [folders_enums_1.MetaTypeEnum.GROUP, folders_enums_1.MetaTypeEnum.UNSPECIFIED, folders_enums_1.MetaTypeEnum.TEAM],
};
exports.FOLDER_PAYMENT_STATUS_OPTIONS = [
    payment_enums_1.PaymentStatusEnum.FULLY_PAID,
    payment_enums_1.PaymentStatusEnum.NOT_PAID,
    payment_enums_1.PaymentStatusEnum.PARTIAL_PAYMENT,
];
exports.FOLDER_PAYMENT_STATUSES_LENGTH = exports.FOLDER_PAYMENT_STATUS_OPTIONS.length;
//# sourceMappingURL=consts.js.map